// src/currencies.js

export const currencies = {
    USD: { symbol: "$" },
    EUR: { symbol: "€" },
    GBP: { symbol: "£" },
    JPY: { symbol: "¥" },
    AUD: { symbol: "A$" },
    // Add more currencies as needed
  };
  